import * as React from 'react';

import { iron, scienceBlue } from '../abstracts/colours';

export interface IconProps {
  fill?: string;
  disabled?: boolean;
}

const CheckboxEmpty: React.SFC<IconProps> = ({ fill = scienceBlue, disabled }) => (
  <svg data-qa-id="checkbox-empty" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd">
      <path d="M0 0L24 0 24 24 0 24z" />
      <rect width="17" height="17" x="3.5" y="3.5" stroke={disabled ? iron : fill} rx="3" />
    </g>
  </svg>
);

export default CheckboxEmpty;
